import { Component, OnInit } from '@angular/core';

import { DEPARTMENT_TYPE_ARBITRATION } from 'src/app/core/constants';

@Component({
  selector: 'app-arbitration-referees',
  templateUrl: './arbitration-referees.component.html',
  styleUrls: ['./arbitration-referees.component.scss']
})
export class ArbitrationRefereesComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Arbitragem
   */
  public departmentType: string = DEPARTMENT_TYPE_ARBITRATION;
  public registerType: string = '2';

  constructor() { }

  ngOnInit(): void {
  }

}
